import { GameConfig } from "../../GameConfig/GameConfig.js";
import { PlayerPickupConfig } from "../../GameConfig/PlayerConfig.js";

export default class TurretAddOn {
  constructor() {
    this.image = new Image();
    this.image.src = PlayerPickupConfig.TURRET.IMG_SRC;

    this.x = 0;
    this.y = 0;

    this.spriteWidth = PlayerPickupConfig.TURRET.SPRITE_WIDTH;
    this.spriteHeight = PlayerPickupConfig.TURRET.SPRITE_HEIGHT;

    this.frameX = 0;
    this.maxFrame = PlayerPickupConfig.TURRET.MAX_FRAME;

    this.fps = GameConfig.FPS;
    this.frameTimer = GameConfig.FRAME_TIMER;
    this.frameInterval = GameConfig.FRAME_INTERVAL();
  }

  draw(context, deltaTime) {
    if (this.frameTimer > this.frameInterval) {
      if (this.frameX < this.maxFrame) this.frameX++;
      else this.frameX = 0;
      this.frameTimer = 0;
    } else if (typeof deltaTime == "number") {
      this.frameTimer = Number(this.frameTimer) + Number(deltaTime);
    }

    context.drawImage(
      this.image,
      this.frameX * this.spriteWidth,
      0,
      this.spriteWidth,
      this.spriteHeight,
      this.x,
      this.y,
      this.spriteWidth,
      this.spriteHeight,
    );
  }

  update(playerX, playerY) {
    this.x = playerX - PlayerPickupConfig.TURRET.X_POS_BUFFER_PX;
    this.y = playerY - PlayerPickupConfig.TURRET.Y_POS_BUFFER_PX;
  }
}
